import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { AlertService, QuestionServiceService } from '../../../services';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css']
})
export class QuestionsComponent implements OnInit, OnChanges {
  @Input() userID;
  @Input() clubProgramID;
  @Input() status: number;
  @Input() cancelText = 'Cancel';

  @Output() cancel = new EventEmitter();
  @Output() save = new EventEmitter();

  form: FormGroup;
  questions = [];

  constructor(
    private service: QuestionServiceService,
    private fb: FormBuilder,
    private loader: Ng4LoadingSpinnerService,
    private alert: AlertService,
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.loader.show();
    this.service.getSetQuestions(this.clubProgramID, 0, this.userID).subscribe(res => {
      if (this.status === 1) {
        this.questions = res.standardQuestionAnswerList || [];
      } else if (this.status === 2) {
        this.questions = res.customQuestionAnswerList || [];
      } else {
        this.questions = (res.standardQuestionAnswerList || []).concat(res.customQuestionAnswerList || []);
      }
      this.buildForm();
      this.loader.hide();
    });
  }

  onCancel() {
    this.buildForm();
    this.cancel.emit();
  }

  onSave() {
    const data = this.questions.map(q => {
      const selectedOption = q.queOptionList && q.queOptionList.length
        && q.queOptionList.find(x => x.clubProgramQuestionOptionID === +this.form.controls[q.label].value);
      const answer = selectedOption ? selectedOption.optionDescription : this.form.controls[q.label].value;

      return {
        userID: +this.userID,
        answer: answer,
        question: q.label,
        clubProgramAnswerID: q.clubprogramanswerID || 0,
        clubProgramQuestionID: q.clubprogramquestionID,
        answerOptionList: []
      };
    });

    this.loader.show();
    this.service.updateAnswer({answers: data}).subscribe(
      () => {
        this.loader.hide();
        this.alert.success('Answers updated');
        this.save.emit();
      },
      () => {
        this.loader.hide();
        this.alert.error('Something went wrong');
      }
    )
  }

  isInvalid(c: string): boolean {
    const control = this.form.get(c);
    return control.touched && !!control.errors;
  }

  private buildForm() {
    const group: any = {};
    this.questions.forEach(question => {
      const selectedOption = question.queOptionList && question.queOptionList.length
        && question.queOptionList.find(x => x.isSelected);
      group[question.label] = [selectedOption ? selectedOption.clubProgramQuestionOptionID : question.answer, [Validators.required]];
    });

    this.form = this.fb.group(group);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/questions/questions.component.ts